import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "welcome-tip"
};
const _hoisted_2 = {
    key: 1,
    class: "loading-tip"
};
const _hoisted_3 = {
    key: 0,
    class: "message-time"
};
const _hoisted_4 = {
    key: 1,
    class: "system-tip"
};
const _hoisted_5 = ["alt"];
const _hoisted_6 = { class: "bubble-wrap" };
const _hoisted_7 = {
    key: 0,
    class: "answer-title"
};
const _hoisted_8 = {
    key: 1,
    class: "content rich-content"
};
const _hoisted_9 = { class: "rich-line" };
const _hoisted_10 = {
    key: 0,
    class: "rich-text"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
    key: 2,
    class: "sticker-row"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src", "onClick"];
const _hoisted_15 = {
    key: 4,
    class: "faq-block"
};
const _hoisted_16 = { class: "faq-label" };
const _hoisted_17 = { class: "faq-chips" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
    key: 2,
    class: "message-row"
};
const _hoisted_20 = ["alt"];
const _hoisted_21 = ["contenteditable"];
const _hoisted_22 = ["disabled", "title"];
const _hoisted_23 = ["disabled"];
const _hoisted_24 = ["disabled"];
const _hoisted_25 = ["title", "disabled", "onClick"];
const _hoisted_26 = ["src", "alt"];
const _hoisted_27 = ["disabled"];
const _hoisted_28 = { class: "action-icon" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = { class: "action-icon" };
const _hoisted_31 = ["src"];
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { registerAppImageHandler, requestAppMedia } from '@/utils/appMedia';
import { CS_EMOJIS, getEmojiImageUrl, parseEmojiContent } from '@/constants/emoji';
import { handleRichInputKeydown, handleRichInputPaste, insertPlainTextToEditor, readClipboardPlainText, insertEmojiWithoutFocus, normalizeEmojiTokensInEditor, RICH_EMOJI_CLASS, saveEditorRangeAtEnd, serializeEditor, setEditorSelection, } from '@/utils/richInput';
import IconCamera from '@/components/icons/IconCamera.vue';
import IconEmoji from '@/components/icons/IconEmoji.vue';
import IconGallery from '@/components/icons/IconGallery.vue';
import IconKeyboard from '@/components/icons/IconKeyboard.vue';
import IconMore from '@/components/icons/IconMore.vue';
import { formatChatMessageTime, shouldShowMessageTime } from '@/utils/messageTime';
import { BOT_OPTIONS_LABEL } from '@/constants/faq';
const AGENT_AVATAR = '/avatar-agent.png';
const PANEL_HEIGHT = 260;
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatPanel',
    props: {
        messages: { default: () => [] },
        agentName: {},
        welcomeText: {},
        disabled: { type: Boolean },
        loading: { type: Boolean },
        typing: { type: Boolean },
        faqItems: { default: () => [] }
    },
    emits: ["send", "send-image", "pick-faq", "request-human"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const optionsLabel = BOT_OPTIONS_LABEL;
        const editorRef = ref(null);
        const listRef = ref(null);
        const composerDockRef = ref(null);
        const inputBarRef = ref(null);
        const hasContent = ref(false);
        const showEmojiPanel = ref(false);
        const showActionPanel = ref(false);
        const galleryInputRef = ref(null);
        const cameraInputRef = ref(null);
        const previewImageUrl = ref('');
        const pasteMenu = ref({ visible: false, x: 0, y: 0, text: '' });
        let longPressTimer;
        let longPressMoved = false;
        let longPressStartX = 0;
        let longPressStartY = 0;
        const panelOpen = computed(() => showEmojiPanel.value || showActionPanel.value);
        const savedRange = ref(null);
        const skipBlurSelectionSave = ref(false);
        /** 底部面板高度基准；打开时会尽量对齐最近一次键盘高度 */
        const dockTotalHeight = ref(52);
        const vvOffset = ref(0);
        const lastKeyboardHeight = ref(PANEL_HEIGHT);
        const activePanelHeight = ref(PANEL_HEIGHT);
        const editorFocused = ref(false);
        function resolvePanelHeight() {
            if (vvOffset.value > 0)
                return vvOffset.value;
            return Math.max(PANEL_HEIGHT, lastKeyboardHeight.value);
        }
        const composerDockStyle = computed(() => {
            if (panelOpen.value || vvOffset.value <= 0)
                return {};
            return { transform: `translateY(-${vvOffset.value}px)` };
        });
        const accessoryPanelStyle = computed(() => {
            const maxH = typeof window !== 'undefined' ? Math.round(window.innerHeight * 0.4) : PANEL_HEIGHT;
            return { height: `${Math.min(activePanelHeight.value, maxH)}px` };
        });
        const listPaddingBottom = computed(() => {
            const keyboardExtra = panelOpen.value ? 0 : vvOffset.value;
            return dockTotalHeight.value + keyboardExtra + 8;
        });
        const panelStyle = computed(() => ({
            '--list-padding-bottom': `${listPaddingBottom.value}px`,
        }));
        let dockObserver;
        let scrollBottomRaf;
        let keyboardScrollTimer;
        function syncViewport() {
            const vv = window.visualViewport;
            if (vv) {
                vvOffset.value = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
                return;
            }
            vvOffset.value = 0;
        }
        function syncDockHeight() {
            if (composerDockRef.value) {
                dockTotalHeight.value = composerDockRef.value.offsetHeight;
            }
        }
        onMounted(() => {
            syncViewport();
            syncDockHeight();
            window.visualViewport?.addEventListener('resize', syncViewport);
            window.visualViewport?.addEventListener('scroll', syncViewport);
            window.addEventListener('keydown', onPreviewKeydown);
            registerAppImageHandler((file) => {
                if (props.disabled)
                    return;
                closePanels();
                emit('send-image', file);
            });
            if (composerDockRef.value && typeof ResizeObserver !== 'undefined') {
                dockObserver = new ResizeObserver(syncDockHeight);
                dockObserver.observe(composerDockRef.value);
            }
        });
        watch(vvOffset, (offset, prev) => {
            if (offset > 80) {
                lastKeyboardHeight.value = offset;
            }
            // 键盘展开/收起时回底；展开过程中 debounce，且不打断用户上滑看历史
            if (prev === 0 && offset > 0) {
                scheduleScrollToBottom();
            }
            else if (prev > 0 && offset === 0) {
                scheduleScrollToBottom();
            }
            else if (!panelOpen.value && offset > 0) {
                if (keyboardScrollTimer)
                    clearTimeout(keyboardScrollTimer);
                keyboardScrollTimer = setTimeout(() => {
                    keyboardScrollTimer = undefined;
                    if (!panelOpen.value && vvOffset.value > 0) {
                        scheduleScrollToBottomIfNearBottom();
                    }
                }, 60);
            }
        });
        watch(panelOpen, () => {
            nextTick(scheduleScrollToBottom);
        });
        onBeforeUnmount(() => {
            window.visualViewport?.removeEventListener('resize', syncViewport);
            window.visualViewport?.removeEventListener('scroll', syncViewport);
            window.removeEventListener('keydown', onPreviewKeydown);
            registerAppImageHandler(null);
            clearLongPressTimer();
            hidePasteMenu();
            dockObserver?.disconnect();
            if (scrollBottomRaf)
                cancelAnimationFrame(scrollBottomRaf);
            if (keyboardScrollTimer)
                clearTimeout(keyboardScrollTimer);
        });
        function saveSelection() {
            const root = editorRef.value;
            const selection = window.getSelection();
            if (!root || !selection || selection.rangeCount === 0)
                return;
            const range = selection.getRangeAt(0);
            if (root.contains(range.commonAncestorContainer)) {
                savedRange.value = range.cloneRange();
            }
        }
        function saveEditorCaretAtEnd() {
            const root = editorRef.value;
            if (!root)
                return;
            savedRange.value = saveEditorRangeAtEnd(root);
        }
        function applyEditorCaretAtEnd() {
            const root = editorRef.value;
            if (!root)
                return;
            if (!savedRange.value) {
                savedRange.value = saveEditorRangeAtEnd(root);
            }
            setEditorSelection(root, savedRange.value);
        }
        function blurEditor() {
            skipBlurSelectionSave.value = true;
            editorRef.value?.blur();
            const active = document.activeElement;
            if (active instanceof HTMLElement && active !== document.body) {
                active.blur();
            }
            nextTick(() => {
                skipBlurSelectionSave.value = false;
            });
        }
        function dismissComposer() {
            hidePasteMenu();
            if (panelOpen.value) {
                closePanels();
            }
            editorFocused.value = false;
            blurEditor();
        }
        let listTouchStartY = 0;
        let listTouchDismissed = false;
        let lastListScrollTop = 0;
        let suppressPopupDismissUntil = 0;
        let programmaticListScroll = false;
        function markSuppressPopupDismiss(ms = 450) {
            suppressPopupDismissUntil = Math.max(suppressPopupDismissUntil, performance.now() + ms);
        }
        function isSuppressPopupDismiss() {
            return performance.now() < suppressPopupDismissUntil;
        }
        function setListScrollTop(top) {
            const el = listRef.value;
            if (!el)
                return;
            programmaticListScroll = true;
            el.scrollTop = top;
            lastListScrollTop = top;
            requestAnimationFrame(() => {
                programmaticListScroll = false;
            });
        }
        function popupActive() {
            return panelOpen.value || pasteMenu.value.visible || vvOffset.value > 0 || editorFocused.value;
        }
        function onListClick() {
            if (isSuppressPopupDismiss())
                return;
            if (!popupActive())
                return;
            dismissComposer();
        }
        function onListTouchStart(event) {
            listTouchStartY = event.touches[0]?.clientY ?? 0;
            listTouchDismissed = false;
            lastListScrollTop = listRef.value?.scrollTop ?? 0;
        }
        function isListNearBottom(threshold = 80) {
            const el = listRef.value;
            if (!el)
                return true;
            return el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
        }
        /** 向上滑动查看历史消息时，收起键盘/表情/更多/粘贴菜单 */
        function onListTouchMove(event) {
            if (listTouchDismissed || !popupActive())
                return;
            const y = event.touches[0]?.clientY ?? 0;
            const deltaY = y - listTouchStartY;
            if (Math.abs(deltaY) < 12)
                return;
            listTouchDismissed = true;
            dismissComposer();
        }
        function onListScroll() {
            const el = listRef.value;
            if (!el)
                return;
            const top = el.scrollTop;
            if (programmaticListScroll) {
                lastListScrollTop = top;
                return;
            }
            if (popupActive() && top > lastListScrollTop + 2) {
                dismissComposer();
            }
            lastListScrollTop = top;
        }
        function openEmojiPanel() {
            markSuppressPopupDismiss(120);
            activePanelHeight.value = resolvePanelHeight();
            showActionPanel.value = false;
            showEmojiPanel.value = true;
            saveEditorCaretAtEnd();
            blurEditor();
            nextTick(() => {
                syncDockHeight();
                scheduleScrollToBottom();
            });
        }
        function openActionPanel() {
            markSuppressPopupDismiss(120);
            activePanelHeight.value = resolvePanelHeight();
            showEmojiPanel.value = false;
            showActionPanel.value = true;
            saveSelection();
            blurEditor();
            nextTick(() => {
                syncDockHeight();
                scheduleScrollToBottom();
            });
        }
        function focusEditor() {
            nextTick(() => {
                const root = editorRef.value;
                if (!root)
                    return;
                saveEditorCaretAtEnd();
                root.focus();
                nextTick(() => applyEditorCaretAtEnd());
            });
        }
        function scheduleScrollToBottomIfNearBottom() {
            if (!isListNearBottom())
                return;
            scheduleScrollToBottom();
        }
        function scheduleScrollToBottom() {
            if (scrollBottomRaf)
                cancelAnimationFrame(scrollBottomRaf);
            scrollBottomRaf = requestAnimationFrame(() => {
                scrollBottomRaf = requestAnimationFrame(() => {
                    scrollBottomRaf = undefined;
                    const el = listRef.value;
                    if (!el)
                        return;
                    setListScrollTop(el.scrollHeight);
                });
            });
        }
        function scrollToBottom() {
            scheduleScrollToBottom();
        }
        watch(() => props.messages?.length ?? 0, () => scrollToBottom(), { immediate: true });
        function getEditorText() {
            if (!editorRef.value)
                return '';
            return serializeEditor(editorRef.value).trim();
        }
        function syncHasContent() {
            if (!editorRef.value) {
                hasContent.value = false;
                return;
            }
            const text = serializeEditor(editorRef.value).replace(/\u200b/g, '').trim();
            const hasEmoji = !!editorRef.value.querySelector(`img.${RICH_EMOJI_CLASS}`);
            hasContent.value = text.length > 0 || hasEmoji;
        }
        function onEditorInput() {
            if (!editorRef.value)
                return;
            normalizeEmojiTokensInEditor(editorRef.value);
            syncHasContent();
        }
        function onEditorChange() {
            syncHasContent();
        }
        function clearEditor() {
            if (editorRef.value)
                editorRef.value.innerHTML = '';
            hasContent.value = false;
        }
        function pickEmoji(data) {
            if (props.disabled || !editorRef.value)
                return;
            if (!savedRange.value) {
                savedRange.value = saveEditorRangeAtEnd(editorRef.value);
            }
            savedRange.value = insertEmojiWithoutFocus(editorRef.value, data, savedRange.value);
            syncHasContent();
        }
        function onEmojiPickStart(event) {
            event.preventDefault();
        }
        function onEditorFocus() {
            editorFocused.value = true;
            hidePasteMenu();
            if (showEmojiPanel.value || showActionPanel.value) {
                closePanels();
            }
            scheduleScrollToBottom();
        }
        function onEditorBlur() {
            if (skipBlurSelectionSave.value)
                return;
            saveSelection();
            window.setTimeout(() => {
                const active = document.activeElement;
                if (active !== editorRef.value) {
                    editorFocused.value = false;
                }
            }, 80);
        }
        function shouldShowMsgTime(msg, index) {
            const prev = index > 0 ? props.messages?.[index - 1] : undefined;
            return shouldShowMessageTime(msg.msgTime, prev?.msgTime);
        }
        function isSelf(message) {
            if (message.role)
                return message.role === 'user';
            if (typeof message.fromSelf === 'boolean')
                return message.fromSelf;
            if (typeof message.fromSelf === 'number')
                return message.fromSelf === 1;
            return false;
        }
        function isSystem(message) {
            return message.role === 'system';
        }
        function agentAvatarAlt() {
            return `${props.agentName || '客服'}头像`;
        }
        function openImagePreview(url) {
            previewImageUrl.value = url;
            closePanels();
            blurEditor();
        }
        function closeImagePreview() {
            previewImageUrl.value = '';
        }
        function onPreviewKeydown(event) {
            if (event.key === 'Escape')
                closeImagePreview();
        }
        function onPickFaq(id) {
            emit('pick-faq', id);
        }
        function onRequestHuman() {
            emit('request-human');
        }
        function toggleEmojiPanel() {
            if (showEmojiPanel.value) {
                showEmojiPanel.value = false;
                focusEditor();
                return;
            }
            openEmojiPanel();
        }
        function toggleActionPanel() {
            if (hasContent.value)
                return;
            if (showActionPanel.value) {
                showActionPanel.value = false;
                return;
            }
            openActionPanel();
        }
        function closePanels() {
            showEmojiPanel.value = false;
            showActionPanel.value = false;
        }
        watch(hasContent, (value) => {
            if (value && showActionPanel.value) {
                showActionPanel.value = false;
            }
        });
        function getStickerList(msg) {
            if (msg.kind === 'face' && msg.faceData)
                return [msg.faceData];
            return [];
        }
        function onImagePicked(event) {
            const inputEl = event.target;
            const file = inputEl.files?.[0];
            inputEl.value = '';
            if (!file || props.disabled)
                return;
            closePanels();
            emit('send-image', file);
        }
        function triggerWebMediaInput(source) {
            const input = source === 'gallery' ? galleryInputRef.value : cameraInputRef.value;
            if (!input)
                return;
            input.value = '';
            input.click();
        }
        function handleMediaPick(source, event) {
            if (props.disabled)
                return;
            event?.preventDefault();
            event?.stopPropagation();
            if (requestAppMedia(source))
                return;
            triggerWebMediaInput(source);
        }
        function hidePasteMenu() {
            pasteMenu.value.visible = false;
            pasteMenu.value.text = '';
        }
        function clearLongPressTimer() {
            if (longPressTimer) {
                clearTimeout(longPressTimer);
                longPressTimer = undefined;
            }
        }
        async function openPasteMenu(clientX, clientY) {
            if (!editorRef.value || props.disabled)
                return;
            const text = await readClipboardPlainText();
            if (!text.trim())
                return;
            pasteMenu.value = {
                visible: true,
                x: clientX,
                y: clientY,
                text,
            };
        }
        function applyPasteMenu() {
            if (!editorRef.value || !pasteMenu.value.text)
                return;
            insertPlainTextToEditor(editorRef.value, pasteMenu.value.text);
            hidePasteMenu();
            nextTick(syncHasContent);
        }
        function onEditorTouchStart(event) {
            if (props.disabled)
                return;
            hidePasteMenu();
            const touch = event.touches[0];
            if (!touch)
                return;
            longPressMoved = false;
            longPressStartX = touch.clientX;
            longPressStartY = touch.clientY;
            clearLongPressTimer();
            longPressTimer = setTimeout(() => {
                if (longPressMoved)
                    return;
                void openPasteMenu(longPressStartX, longPressStartY);
            }, 500);
        }
        function onEditorTouchMove(event) {
            const touch = event.touches[0];
            if (!touch)
                return;
            if (Math.abs(touch.clientX - longPressStartX) > 8 ||
                Math.abs(touch.clientY - longPressStartY) > 8) {
                longPressMoved = true;
                clearLongPressTimer();
            }
        }
        function onEditorTouchEnd() {
            clearLongPressTimer();
        }
        function onEditorBeforeInput(event) {
            if (!editorRef.value || props.disabled)
                return;
            if (event.inputType !== 'insertFromPaste')
                return;
            event.preventDefault();
            const text = event.data ?? '';
            if (!text)
                return;
            insertPlainTextToEditor(editorRef.value, text);
            nextTick(syncHasContent);
        }
        function onEditorContextMenu(event) {
            if (props.disabled)
                return;
            void openPasteMenu(event.clientX, event.clientY);
        }
        function onEditorPaste(event) {
            if (!editorRef.value || props.disabled)
                return;
            handleRichInputPaste(event, editorRef.value);
            hidePasteMenu();
            nextTick(syncHasContent);
        }
        function submit() {
            const text = getEditorText();
            if (!text || props.disabled)
                return;
            emit('send', text);
            clearEditor();
            closePanels();
        }
        function onEditorKeydown(event) {
            if (editorRef.value && handleRichInputKeydown(event, editorRef.value)) {
                nextTick(syncHasContent);
                return;
            }
            if (event.key !== 'Enter')
                return;
            if (event.altKey)
                return;
            event.preventDefault();
            submit();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "chat-panel",
                style: _normalizeStyle(panelStyle.value)
            }, [
                _createElementVNode("div", {
                    ref_key: "listRef",
                    ref: listRef,
                    class: "message-list",
                    onClick: onListClick,
                    onScrollPassive: onListScroll,
                    onTouchstartPassive: onListTouchStart,
                    onTouchmovePassive: onListTouchMove
                }, [
                    (__props.welcomeText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.welcomeText), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    (__props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "加载消息中…"))
                        : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (msg, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                            key: msg.msgId || `${msg.msgTime}-${index}`
                        }, [
                            (shouldShowMsgTime(msg, index))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(formatChatMessageTime)(msg.msgTime)), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (isSystem(msg))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(msg.content), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["message-row", { self: isSelf(msg) }])
                                }, [
                                    (!isSelf(msg))
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "avatar",
                                            src: AGENT_AVATAR,
                                            alt: agentAvatarAlt()
                                        }, null, 8 /* PROPS */, _hoisted_5))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["bubble", {
                                                    'bubble-image': msg.kind === 'image',
                                                    'bubble-face': msg.kind === 'face',
                                                }])
                                        }, [
                                            (msg.title)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(msg.title), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            (msg.content && msg.kind !== 'face' && msg.kind !== 'image')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    _createElementVNode("span", _hoisted_9, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parseEmojiContent)(msg.content), (part, partIndex) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, { key: partIndex }, [
                                                                (part.type === 'text')
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(part.value), 1 /* TEXT */))
                                                                    : (_openBlock(), _createElementBlock("img", {
                                                                        key: 1,
                                                                        class: "face-img inline-face",
                                                                        src: _unref(getEmojiImageUrl)(part.value),
                                                                        alt: "表情"
                                                                    }, null, 8 /* PROPS */, _hoisted_11))
                                                            ], 64 /* STABLE_FRAGMENT */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ]))
                                                : (getStickerList(msg).length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getStickerList(msg), (sticker, stickerIndex) => {
                                                            return (_openBlock(), _createElementBlock("img", {
                                                                key: `${sticker}-${stickerIndex}`,
                                                                class: "face-img",
                                                                src: _unref(getEmojiImageUrl)(sticker),
                                                                alt: "表情"
                                                            }, null, 8 /* PROPS */, _hoisted_13));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                            (msg.kind === 'image' && msg.imageUrl)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 3,
                                                    class: "msg-image",
                                                    src: msg.imageUrl,
                                                    alt: "图片",
                                                    onClick: _withModifiers(($event) => (openImagePreview(msg.imageUrl)), ["stop"])
                                                }, null, 8 /* PROPS */, _hoisted_14))
                                                : _createCommentVNode("v-if", true),
                                            (msg.showOptions && __props.faqItems.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(optionsLabel)), 1 /* TEXT */),
                                                    _createElementVNode("div", _hoisted_17, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.faqItems, (item) => {
                                                            return (_openBlock(), _createElementBlock("button", {
                                                                key: item.id,
                                                                type: "button",
                                                                class: "faq-chip",
                                                                onClick: ($event) => (onPickFaq(item.id))
                                                            }, _toDisplayString(item.question), 9 /* TEXT, PROPS */, _hoisted_18));
                                                        }), 128 /* KEYED_FRAGMENT */)),
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "faq-chip faq-chip--human",
                                                            onClick: onRequestHuman
                                                        }, " 人工客服 ")
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ], 2 /* CLASS */)
                                    ])
                                ], 2 /* CLASS */))
                        ], 64 /* STABLE_FRAGMENT */));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (__props.typing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("img", {
                                class: "avatar",
                                src: AGENT_AVATAR,
                                alt: agentAvatarAlt()
                            }, null, 8 /* PROPS */, _hoisted_20),
                            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"bubble-wrap\" data-v-434b0247><div class=\"bubble typing-bubble\" data-v-434b0247><span class=\"typing-dot\" data-v-434b0247></span><span class=\"typing-dot\" data-v-434b0247></span><span class=\"typing-dot\" data-v-434b0247></span></div></div>", 1))
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 544 /* NEED_HYDRATION, NEED_PATCH */),
                _createElementVNode("div", {
                    ref_key: "composerDockRef",
                    ref: composerDockRef,
                    class: "composer-dock",
                    style: _normalizeStyle(composerDockStyle.value)
                }, [
                    _createElementVNode("div", {
                        ref_key: "inputBarRef",
                        ref: inputBarRef,
                        class: "input-bar"
                    }, [
                        _createElementVNode("form", {
                            class: "input-form",
                            onSubmit: _withModifiers(submit, ["prevent"])
                        }, [
                            _createElementVNode("div", {
                                ref_key: "editorRef",
                                ref: editorRef,
                                class: "rich-input rich-content",
                                contenteditable: __props.disabled ? 'false' : 'true',
                                enterkeyhint: "send",
                                "data-placeholder": "输入消息",
                                onFocus: onEditorFocus,
                                onBlur: onEditorBlur,
                                onInput: onEditorInput,
                                onKeyup: onEditorChange,
                                onCompositionend: onEditorChange,
                                onKeydown: onEditorKeydown,
                                onPaste: onEditorPaste,
                                onBeforeinput: onEditorBeforeInput,
                                onTouchstart: _withModifiers(onEditorTouchStart, ["stop"]),
                                onTouchmove: _withModifiers(onEditorTouchMove, ["stop"]),
                                onTouchend: _withModifiers(onEditorTouchEnd, ["stop"]),
                                onTouchcancel: _withModifiers(onEditorTouchEnd, ["stop"]),
                                onContextmenu: _withModifiers(onEditorContextMenu, ["prevent"])
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21)
                        ], 32 /* NEED_HYDRATION */),
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["round-btn tool-toggle-btn", { 'tool-toggle-btn--keyboard': showEmojiPanel.value }]),
                            disabled: __props.disabled,
                            title: showEmojiPanel.value ? '键盘' : '表情',
                            onClick: _withModifiers(toggleEmojiPanel, ["stop"])
                        }, [
                            _createVNode(IconEmoji, { class: "tool-icon-svg tool-toggle-icon tool-toggle-icon--emoji" }),
                            _createVNode(IconKeyboard, { class: "tool-icon-svg tool-toggle-icon tool-toggle-icon--keyboard" })
                        ], 10 /* CLASS, PROPS */, _hoisted_22),
                        _createElementVNode("div", {
                            class: _normalizeClass(["action-slot", { 'action-slot--send': hasContent.value }])
                        }, [
                            _createVNode(_Transition, { name: "action-switch" }, {
                                default: _withCtx(() => [
                                    (!hasContent.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: "more",
                                            type: "button",
                                            class: _normalizeClass(["round-btn more-btn", { active: showActionPanel.value }]),
                                            disabled: __props.disabled,
                                            title: "更多",
                                            onClick: _withModifiers(toggleActionPanel, ["stop"])
                                        }, [
                                            _createVNode(IconMore, { class: "tool-icon-svg" })
                                        ], 10 /* CLASS, PROPS */, _hoisted_23))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: "send",
                                            type: "button",
                                            class: "send-btn",
                                            disabled: __props.disabled,
                                            title: "发送",
                                            onClick: submit
                                        }, " 发送 ", 8 /* PROPS */, _hoisted_24))
                                ]),
                                _: 1 /* STABLE */
                            })
                        ], 2 /* CLASS */)
                    ], 512 /* NEED_PATCH */),
                    _withDirectives(_createElementVNode("div", {
                        class: "accessory-panel emoji-panel",
                        style: _normalizeStyle(accessoryPanelStyle.value),
                        onPointerdown: onEmojiPickStart
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CS_EMOJIS), (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: item.data,
                                type: "button",
                                class: "emoji-item",
                                title: item.label,
                                disabled: __props.disabled,
                                onPointerdown: onEmojiPickStart,
                                onClick: ($event) => (pickEmoji(item.data))
                            }, [
                                _createElementVNode("img", {
                                    src: item.imageUrl,
                                    alt: item.label
                                }, null, 8 /* PROPS */, _hoisted_26)
                            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_25));
                        }), 128 /* KEYED_FRAGMENT */))
                    ], 36 /* STYLE, NEED_HYDRATION */), [
                        [_vShow, showEmojiPanel.value]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                        class: "accessory-panel action-panel",
                        style: _normalizeStyle(accessoryPanelStyle.value)
                    }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["action-item", { 'action-item--disabled': __props.disabled }]),
                            disabled: __props.disabled,
                            onClick: _cache[0] || (_cache[0] = ($event) => (handleMediaPick('gallery', $event)))
                        }, [
                            _createElementVNode("span", _hoisted_28, [
                                _createVNode(IconGallery, { class: "action-icon-svg" })
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "action-label" }, "图片", -1 /* CACHED */))
                        ], 10 /* CLASS, PROPS */, _hoisted_27),
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["action-item", { 'action-item--disabled': __props.disabled }]),
                            disabled: __props.disabled,
                            onClick: _cache[1] || (_cache[1] = ($event) => (handleMediaPick('camera', $event)))
                        }, [
                            _createElementVNode("span", _hoisted_30, [
                                _createVNode(IconCamera, { class: "action-icon-svg" })
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "action-label" }, "拍摄", -1 /* CACHED */))
                        ], 10 /* CLASS, PROPS */, _hoisted_29)
                    ], 4 /* STYLE */), [
                        [_vShow, showActionPanel.value]
                    ])
                ], 4 /* STYLE */),
                _createElementVNode("input", {
                    ref_key: "galleryInputRef",
                    ref: galleryInputRef,
                    type: "file",
                    accept: "image/*",
                    tabindex: "-1",
                    "aria-hidden": "true",
                    class: "media-input-fallback",
                    onChange: onImagePicked
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                _createElementVNode("input", {
                    ref_key: "cameraInputRef",
                    ref: cameraInputRef,
                    type: "file",
                    accept: "image/*",
                    capture: "environment",
                    tabindex: "-1",
                    "aria-hidden": "true",
                    class: "media-input-fallback",
                    onChange: onImagePicked
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (pasteMenu.value.visible)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "paste-menu",
                            style: _normalizeStyle({ left: `${pasteMenu.value.x}px`, top: `${pasteMenu.value.y}px` }),
                            onClick: _withModifiers(applyPasteMenu, ["stop"])
                        }, " 粘贴 ", 4 /* STYLE */))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_Transition, { name: "image-preview" }, {
                        default: _withCtx(() => [
                            (previewImageUrl.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "image-preview",
                                    role: "dialog",
                                    "aria-modal": "true",
                                    "aria-label": "图片预览",
                                    onClick: closeImagePreview
                                }, [
                                    _createElementVNode("img", {
                                        class: "image-preview__img",
                                        src: previewImageUrl.value,
                                        alt: "图片预览"
                                    }, null, 8 /* PROPS */, _hoisted_31)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]))
            ], 4 /* STYLE */));
        };
    }
});
